// extracted by mini-css-extract-plugin
module.exports = {"container":"text-inline-image-section-wrapper_container__ccBYZ","imageContainer":"text-inline-image-section-wrapper_imageContainer__wDv0N"};